/**
 * STORAGE SERVICE (Cloudinary Mode)
 * 
 * Uploads images to Cloudinary's free tier.
 * No database size limits.
 * Automatic optimization and CDN delivery.
 */

// Configuration
const CLOUD_NAME = process.env.VITE_CLOUDINARY_CLOUD_NAME || 'dwumc6xi2'; 
// You must create this Unsigned preset in Cloudinary Settings -> Upload
const UPLOAD_PRESET = process.env.VITE_CLOUDINARY_PRESET || 'iqodex_preset'; 

/**
 * Uploads an image file to Cloudinary and returns the public URL.
 */
export const uploadProjectPreview = async (file: File, projectId: string, type: 'desktop' | 'mobile'): Promise<string> => {
  
  // 1. Basic Validation
  if (!file.type.startsWith('image/')) {
    throw new Error("Only image files are allowed.");
  }

  // 2. Prepare Form Data for Cloudinary API
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  
  // Optional: Organize into folders (e.g. iqodex/day_1/)
  formData.append('folder', `iqodex/day_${projectId}`);
  
  // Optional: Add tag for easier management
  formData.append('tags', `day_${projectId},${type}`);

  try {
      console.log(`Uploading ${type} to Cloudinary (${CLOUD_NAME})...`);
      
      const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
          method: 'POST',
          body: formData
      });

      const data = await response.json();

      if (!response.ok) {
          console.error("Cloudinary Detailed Error:", JSON.stringify(data, null, 2));
          
          let errorMessage = "Upload failed";
          if (data.error) {
              errorMessage = data.error.message || "Unknown Cloudinary API Error";
          }
          
          // Helpful hints for common errors
          if (errorMessage.includes('upload_preset')) {
             throw new Error(`Cloudinary Config Error: The Upload Preset '${UPLOAD_PRESET}' is invalid or not set to 'Unsigned'.`);
          }
          if (errorMessage.includes('cloud_name')) {
             throw new Error(`Cloudinary Config Error: The Cloud Name '${CLOUD_NAME}' is invalid.`);
          }
          
          throw new Error(`API Error: ${errorMessage}`);
      }

      // Success! Return the HTTPS URL
      return data.secure_url;
      
  } catch (error: any) {
      console.error("Upload Service Exception:", error);
      throw new Error(error.message || "Failed to upload image. Check console for details.");
  }
};